<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">
                  Администрирование списка ГК
                </div>
                <div class="pull-right">
                  <router-link
                    :to="{
                      name: 'GroupOrgs'
                    }"
                    class="btn btn-success"
                    style="margin-right: 12px"
                  >
                    Группы компаний
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form>
              <div class="row myrow project-filter filter-wrapper-stl">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!listRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    :multiple="true"
                    v-model="filter.org"
                    :options="orgs"
                    placeholder="Группа компаний"
                  />
                </div>
                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      @click="clearFilter"
                      type="button"
                    >
                      СБРОС
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-full"
                      type="button"
                      @click="fetchList"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="table-responsive container-stl"
            v-if="!isGroupOrgsLoading"
          >
            <table class="table  table-hover table-striped">
              <thead>
                <tr>
                  <th class="text-nowrap">
                    №<a
                      v-on:click="setOrder('ID')"
                      class="sort"
                      v-bind:class="{
                        desc: sortColumn === 'ID' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Группа компаний<a
                      href="#"
                      v-on:click="setOrder('UF_NAME')"
                      class="sort"
                      v-bind:class="{
                        desc: sortColumn === 'UF_NAME' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Госкорпорация<a
                      v-on:click="setOrder('UF_IS_STATE_CORPORATION')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_IS_STATE_CORPORATION' &&
                          sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Комментарий<a
                      v-on:click="setOrder('UF_COMMENT')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_COMMENT' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <td></td>
                </tr>
              </thead>
              <tbody v-if="groupOrgs.counts">
                <tr
                  class="new"
                  unselectable="on"
                  v-for="project in groupOrgs.items"
                  v-bind:key="project.ID"
                  style="cursor: default"
                >
                  <td>{{ project.ID }}</td>
                  <td>{{ project.UF_NAME }}</td>
                  <td>{{ project.UF_IS_STATE_CORPORATION ? "Да" : "Нет" }}</td>
                  <td>{{ project.UF_COMMENT }}</td>
                  <td>
                    <a
                      v-if="isEdit"
                      @click="getItem(project)"
                      class="link-edit-row"
                    ></a>
                  </td>
                  <td>
                    <a
                      v-if="isEdit"
                      @click="deleteItem(project)"
                      class="link-delete-row"
                    ></a>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">Записи не найдены</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="10" style="border-top: 0px;">
                    <div class="paging">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-xs-6 mycol">
                            <Pagination
                              :pages="pages"
                              :currentPage.sync="currentPage"
                            ></Pagination>
                          </div>
                          <div class="col-xs-6 mycol">
                            <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                                >Всего: {{ groupOrgs.counts }}</span
                              >
                              <span>Выводить по </span>
                              <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>
          <div
            class="modal fade in"
            v-bind:class="{ show: showCreateNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onCreateProject">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showCreateNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Добавление группы компаний</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>

                    <div class="form-group">
                      <label>Название</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newProject.name"
                      />
                    </div>
                    <div class="form-group">
                      <label>Госкорпорация</label>
                      <select
                        class="form-control"
                        v-model="newProject.goscompany"
                      >
                        <option :value="0">Нет</option>
                        <option :value="1">Да</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Комментарий</label>
                      <textarea
                        class="form-control"
                        v-model="newProject.comment"
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="showCreateNewProject = false"
                    >
                      Отмена
                    </button>
                    <button
                      type="submit"
                      v-bind:disabled="isGroupOrgsLoading"
                      class="btn btn-primary"
                    >
                      Создать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showEditNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onEditProject">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showEditNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Редактирование ГК</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>

                    <div class="form-group">
                      <label>Название</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newProject.name"
                      />
                    </div>
                    <div class="form-group">
                      <label>Госкорпорация</label>
                      <select
                        class="form-control"
                        v-model="newProject.goscompany"
                      >
                        <option :value="0">Нет</option>
                        <option :value="1">Да</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Комментарий</label>
                      <textarea
                        class="form-control"
                        v-model="newProject.comment"
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="showEditNewProject = false"
                    >
                      Отмена
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Редактировать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
        </div>
      </div>
      <!-- wraper -->
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right">
            <a
              class="btn btn-success"
              style="margin-right: 12px;padding: 3px 12px"
              v-if="isEdit"
              @click="showCreateForm"
            >
              Добавить
            </a>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  FETCH_PROJECT_TYPES,
  SET_MAIN_MENU,
  FETCH_DIRECTORIES,
  FETCH_GROUP_ORGS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE
} from "../../store/actions.type";
import { GroupOrgs, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Item from "@/components/expert/Item";
import Multiselect from "vue-multiselect";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  title: "Реестр проектов",
  components: {
    Pagination,
    Multiselect
  },
  data() {
    return {
      extendFilter: false,
      filter: {
        org: ""
      },
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showEditNewProject: false,
      sp: {
        statuses: []
      },
      newProject: {
        comment: "",
        goscompany: "0",
        name: ""
      },
      addError: "",
      addresses: [],
      addressSearch: "",
      selectedAddress: null,
      items: [],
      orgs: [],
      listRendered: false,
      act: Item,
      ea: {},
      isEdit: false
    };
  },
  async mounted() {
    await this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        this.isEdit = data.IS_REDACT_GROUP_ORG;
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }*/
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          /*if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }*/
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      });
    } else {
      await this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "status",
      "program_fin_support",
      "type_making"
    ]);
    GroupOrgs.getListGroupOrgs({ allList: 1 }).then(({ data }) => {
      this.orgs = data.items;
      this.listRendered = true;
      this.fetchList();
    }, this);
  },
  computed: {
    ...mapGetters([
      "groupOrgs",
      "isGroupOrgsLoading",
      "currentUser",
      "directory"
    ]),
    createProjectButton() {
      if (this.currentUser.TYPE_USER === "declarer") {
        return true;
      }
      return false;
    },
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }

      if (this.filter.org.length) {
        q.filter.ID = [];
        this.filter.org.forEach(function(it) {
          q.filter.ID.push(it.ID);
        }, this);
      }

      return q;
    },
    pages() {
      if (
        this.isGroupOrgsLoading ||
        this.groupOrgs.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.groupOrgs.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchList();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchList();
    },
    addressSearch(addr) {
      this.getAddresses(addr);
    }
  },
  methods: {
    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchList();
    },
    clearFilter() {
      this.filter = {
        org: []
      };
      this.fetchList();
    },
    onCreateProject() {
      GroupOrgs.addGroupOrgs({
        UF_NAME: this.newProject.name,
        UF_IS_STATE_CORPORATION: this.newProject.goscompany,
        UF_COMMENT: this.newProject.comment
      })
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchList();
            this.showCreateNewProject = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    showCreateForm() {
      this.newProject.name = "";
      this.newProject.goscompany = 0;
      this.newProject.comment = "";
      this.showCreateNewProject = true;
    },
    onEditProject() {
      GroupOrgs.editGroupOrgs(this.newProject.ID, {
        UF_NAME: this.newProject.name,
        UF_IS_STATE_CORPORATION: this.newProject.goscompany,
        UF_COMMENT: this.newProject.comment
      })
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchList();
            this.showEditNewProject = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    showCreateProjectPanel() {
      this.$store.dispatch(FETCH_PROJECT_TYPES).then(() => {
        this.addError = "";
        this.showCreateNewProject = true;
      });
    },
    fetchList() {
      this.$store.dispatch(FETCH_GROUP_ORGS_LIST, this.listConfig);
    },
    getLinkProjects() {
      GroupOrgs.getLinkReestrAdviceProjectExcel(
        this.$route.params.id,
        this.listConfig
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    async getAddresses(query) {
      await GroupOrgs.searchProject({ search: query }).then(({ data }) => {
        let ad = [];
        for (let i = 0; i < data.length; i++) {
          ad.push({
            id: data[i].ID,
            text: data[i].UF_NAME
          });
        }
        let adj = JSON.stringify(ad);
        this.addresses = JSON.parse(adj);
      });
    },
    deleteItem(item) {
      if (confirm("Удалить группу компаний?")) {
        GroupOrgs.deleteGroupOrgs(item.ID).then(({ data }) => {
          if (data.errorAr && data.errorAr.length) {
            this.$toasted.show(data.errorAr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchList();
          }
        }, this);
        return false;
      }
    },
    getItem(item) {
      GroupOrgs.getGroupOrgs(item.ID)
        .then(({ data }) => {
          this.newProject.ID = item.ID;
          this.newProject.name = data.UF_NAME;
          this.newProject.goscompany = data.UF_IS_STATE_CORPORATION;
          this.newProject.comment = data.UF_COMMENT;
          this.showEditNewProject = true;
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    getLabel(item) {
      return item.UF_NUMBER + " " + item.UF_NAME;
    },
    updateItems(query) {
      GroupOrgs.searchProject({ search: query }).then(({ data }) => {
        this.items = data;
      });
    },
    filterItemText(count) {
      return `и еще ${count}`;
    }
  }
};
</script>
